import { Component, OnInit, NgZone, } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormArray } from '@angular/forms';
import { environment } from '../../../../../environments/environment';
import { AuthservicesService } from '../../../../services/authservices.service';
import { Router } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';
@Component({
  selector: 'app-custom-text-fields',
  templateUrl: './custom-text-fields.component.html',
  styleUrls: ['./custom-text-fields.component.css']
})
export class CustomTextFieldsComponent implements OnInit {
  form: FormGroup;
  customCategory: FormArray;
  submitted = false;
  errorMessage
  currentUser
  titleText: '';
  communityData
  completeReg: boolean = false
  constructor(private authService: AuthservicesService, private fb: FormBuilder, private router: Router) { }
  ngOnInit(): void {

    this.currentUser = JSON.parse(localStorage.getItem('ministry_currentUser'))
    this.getCommunityId(this.currentUser)
    this.errorMessage = environment.errorMessage
    this.form = this.fb.group({
      customCategory: this.fb.array([this.createItem()])
    })
    console.log("form", this.form);

  }
   get f() {
    return this.form.controls;
  }
  createItem() {
    return this.fb.group({                                          
      description: [''],
      title: [''],
    })
  }


  addArr() {
    this.customCategory = this.form.get('customCategory') as FormArray;
    this.customCategory.push(this.createItem());
  }

  removeAddress(i) {
    this.customCategory = this.form.get('customCategory') as FormArray;
    this.customCategory.removeAt(i)

  }

  fetchData() {
    if (this.communityData.customCategory.length != 0) {
      this.customCategory = this.form.get('customCategory') as FormArray;

      this.communityData.customCategory.forEach(e => {

        this.customCategory.push(this.fb.group({
          description: e.description,
          title: e.title
        }))
      });
      this.customCategory.removeAt(0)


    }
  }




  getCommunityId(data) {
    let id
    if (data) {
      id = this.currentUser.id
    }
    this.authService.getCommunityByid(id).subscribe((res: any) => {
      this.communityData = res.data;
      this.fetchData();
    },
      error => {
        console.log(error)
      })
  }




  redirect() {
    this.router.navigate(['/user-registration/about-us'])
  }

  onSubmit() {
    this.submitted = true;
    if (this.form.invalid) {
      this.authService.scrollToError();
      return;
    }

    this.authService.signUpCustomfieldtext(this.form.value).subscribe((res: any) => {

      console.log('ressssssssssssssssss', res)

      const helper = new JwtHelperService();
      const decodedToken = helper.decodeToken(res?.data?.token);
      localStorage.setItem('currentUser1', JSON.stringify(decodedToken));

      this.completeReg = true
      localStorage.setItem('completeReg', JSON.stringify(this.completeReg));

      
      // this.authService.successMessage(res.message, 'success')
      if(!decodedToken?.isEmailVarified) {
        this.router.navigate(['/email-verification']);
      }
      else {
      this.router.navigate(['/profile-management']);
      }
    },
      error => {
        if (error.error.code == '401') {
          this.authService.refreshToken();
        }
        this.authService.successMessage(error.error.message, 'error')
        console.log(error)
      })
  }
}
